import React, { createContext } from 'react';

const AppConfigListContext = createContext();

export default AppConfigListContext;
